<script>
  export let icon;

  let image = "";
  let color = "";
  
  if (icon === "shelf") {
    image = "/book.png";
    color = "#0F0";
  } else if (icon === "star") {
    image = "/star.png";
    color = "transparent";
  } else if (icon === "no") {
    image = "/cal.png";
    color = "#F00";
  }

</script>

<style>
  div {
    display: inline-block;
    width: 22px;
    height: 22px;
    line-height: 22px;
    /*background: #0F0;*/
    /*position: relative;*/
    border-radius: 100px;
    text-align: center;
    margin-right: 3px;
  }

  img {
    vertical-align: middle;
    max-width: 10px;
    max-height: 10px;
    position: relative;
    top: -1px;
  }
</style>

<div style="background: {color}">
  <img src={image}>
</div>